import { render, staticRenderFns } from "./TeacherFloating.vue?vue&type=template&id=4b01e166&scoped=true"
import script from "./TeacherFloating.vue?vue&type=script&lang=js"
export * from "./TeacherFloating.vue?vue&type=script&lang=js"
import style0 from "./TeacherFloating.vue?vue&type=style&index=0&id=4b01e166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b01e166",
  null
  
)

export default component.exports